module.exports = __webpack_public_path__ + "img/image-2-v2.add34615.jpg";